import styled from "styled-components";

export const SettingsConfigPageStyle = styled.div`
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    max-width: 1280px;
    padding: 10px 10px;
    border: 1px solid rgba(45, 45, 45, 0.15);
    max-width: 1280px;
    width: 100%;
    min-height: 60vh;
    background-color: #fff !important;
    margin: 0 auto;

    .topPageContainer {
        display: flex;
        position: relative;
        width: 100%;
    }

    .instructionsContainer {
        cursor: pointer;
        position: absolute;
        right: 5%;
        display: flex;
        align-items: center;
        border-radius: 8px;
        padding: 5px 10px !important;
        box-shadow: 0px 0px 2px #8888889e;
        transition: 0.3s;
        background-color: #8888883e;
        &:hover {
            background-color: #8888889e;
        }
    }

    .instructionsContainer p {
        margin: 0;
        padding: 0;
    }

    h2 {
        margin-top: 40px;
        text-align: center;
        width: 100%;
    }

    .settings-section {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 24px;
    }

    .settings-block {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
    }

    .settings-block--separated {
        margin-top: 28px;
        padding-top: 24px;
        border-top: 1px solid rgba(45, 45, 45, 0.12);
    }

    .settings-block h4 {
        margin: 0 0 4px;
        width: 600px;
        max-width: 100%;
        text-align: left;
        color: var(--primary, #172b4d);
    }

    .inputAndLoadingContainer {
        position: relative;
        width: 600px;
        max-width: 100%;
    }

    .inputs {
        width: 100%;
    }

    .setting-helper-text {
        margin: 6px 0 0;
        text-align: left;
        font-size: 0.75rem;
        color: rgba(0, 0, 0, 0.6);
    }

    .toggle {
        display: flex;
        flex-direction: column-reverse;
    }

    @media (max-width: 740px) {
        .inputs,
        .inputAndLoadingContainer,
        .settings-block h4 {
            width: 100%;
        }

        @media (max-width: 400px) {
            box-shadow: none;
        }
    }
`;
